import { LayoutModeType, MenuMode, ThemeModeType } from '@osos/shared/types';

export const FONT_SCALES = [12, 13, 14, 15, 16];
export const FONT_BASE_SIZE = 14;
export const BASE_THEME: ThemeModeType = 'gold';
export const BASE_MENU: MenuMode = MenuMode.Icons;
export const BASE_LAYOUT: LayoutModeType = 'light';
export const MENU_MODES = [
  { value: MenuMode.Icons, text: MenuMode.Icons },
  { value: MenuMode.Static, text: MenuMode.Static },
  { value: MenuMode.Overlay, text: MenuMode.Overlay },
  { value: MenuMode.Slim, text: MenuMode.Slim },
];
